import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Library, Briefcase, Search, Share2, Sparkles, Globe, BotMessageSquare, Zap } from 'lucide-react';

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/library', icon: Library, label: 'Library' },
    { path: '/zap-tools', icon: Zap, label: 'Zap Tools' },
    { path: '/search', icon: BotMessageSquare, label: 'Consult AI' },
    { path: '/workspace', icon: Briefcase, label: 'Workspace' },
    { path: '/synthesis', icon: Sparkles, label: 'Synthesis' },
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-700 shadow-lg z-50">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                  active
                    ? 'text-purple-600 dark:text-purple-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-purple-500'
                }`}
              >
                <Icon size={20} className="mb-0.5 sm:mb-1" />
                <span className="text-[10px] sm:text-xs font-medium truncate max-w-[60px] sm:max-w-none">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}

export default BottomNav;